import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '../../atoms';
import { useReporter } from '../../reporter';
import { InfoLink } from '../InfoLink';
import { RecipeNavLink } from '../RecipeNavLink';
import { userSelectsDashboardMealPrep } from './events';
import { InfoContainer } from './styles.js';

export const BoxManagementNav = ({
  label,
  petId,
  shippingDate,
  frequency,
  shippingInfo,
  paymentInfo,
  product,
  mealPrep,
}) => {
  const reporter = useReporter();
  return (
    <>
      <Heading
        headingLevel="h2"
        typography={{ desktop: 'heading2', mobile: 'heading1' }}
        headingText={label}
      />
      <InfoContainer>
        <InfoLink
          title="Delivery date"
          href={{
            pathname: '/account/edit-delivery-date/quick',
            query: { pet_id: petId },
          }}
          infoList={shippingDate}
        />
        <InfoLink
          title="Box frequency"
          href={{
            pathname: '/account/alter-frequency',
            query: { pet_id: petId },
          }}
          infoList={frequency}
        />
        <InfoLink
          title="Meal plan"
          onInfoClick={() => reporter.tag(userSelectsDashboardMealPrep())}
          href={{
            pathname: '/account/edit-recipes/mealprep',
            query: { pet_id: petId },
          }}
          infoList={mealPrep}
        />
        <RecipeNavLink
          title="Recipes"
          freshHref={{
            pathname: '/account/edit-recipes/recipes/fresh/',
            query: { pet_id: petId, meal_prep: product.variable },
          }}
          bakedHref={{
            pathname: '/account/edit-recipes/recipes/baked/',
            query: { pet_id: petId, meal_prep: product.variable },
          }}
          recipes={product.recipes}
        />
        <InfoLink
          title="Shipping address"
          href="/account/edit-shipping-address"
          infoList={shippingInfo}
        />
        <InfoLink
          title={
            paymentInfo.length > 0 ? 'Payment info' : 'Add new payment method'
          }
          href="/account/edit-payment"
          infoList={paymentInfo}
        />
      </InfoContainer>
    </>
  );
};

BoxManagementNav.propTypes = {
  label: PropTypes.string.isRequired,
  petId: PropTypes.string.isRequired,
  shippingDate: PropTypes.arrayOf(PropTypes.string).isRequired,
  frequency: PropTypes.arrayOf(PropTypes.string).isRequired,
  shippingInfo: PropTypes.arrayOf(PropTypes.string).isRequired,
  paymentInfo: PropTypes.arrayOf(PropTypes.string).isRequired,
  mealPrep: PropTypes.arrayOf(PropTypes.string).isRequired,
  product: PropTypes.shape({
    variable: PropTypes.string,
    recipes: PropTypes.shape({
      fresh: PropTypes.arrayOf(PropTypes.string),
      dry: PropTypes.arrayOf(PropTypes.string),
    }),
  }),
};
